export default __webpack_public_path__ + "assets/images/f5b83e872711a0c393bd45c2ca961cb4.svg";